import {
  flagStatuses,
  reportsLabels,
  resolutionStatuses,
} from "../../utils/vars";

export const CRITERIA_KIND = {
  SELECT: "select",
  GROUP: "group",
};

export const CRITERIA_TYPES = ["RULE", "STATUS", "RESOLUTION", "REPORT"];

export const SELECT_POST_KEYS = {
  RULE: "rules",
  REPORT: "reports",
  RESOLUTION: "resolutions",
  STATUS: "statuses",
};

export const GROUP_POST_KEYS = {
  RULE: "groupRules",
  REPORT: "groupReports",
  RESOLUTION: "groupResolutions",
  STATUS: "groupStatuses",
};

export const TYPE_LABEL_KEYS = {
  RULE: "auditTrail.rule",
  STATUS: "auditTrail.status",
  RESOLUTION: "auditTrail.resolution",
  REPORT: "auditTrail.report",
};

const ALL_OPTION = { value: "ALL", label: "All" };

const EMPTY_OPTIONS = CRITERIA_TYPES.reduce(
  (acc, type) => ({ ...acc, [type]: [] }),
  {},
);

const NUMERIC_ID_TYPES = new Set(["RULE"]);

// Mantine Select requires string `value`s. Numeric ids (RULE) must be
// stringified for the UI and converted back when building the backend payload.
export const toBackendValue = (type, val) =>
  NUMERIC_ID_TYPES.has(type) && val !== "ALL" ? Number(val) : val;

export const buildOptions = (dropdownData) => {
  if (!dropdownData) return EMPTY_OPTIONS;
  const { rules, statuses, resolutions, reports } = dropdownData;

  const idOpt = (item) => ({ value: String(item.id), label: item.name });
  const enumOpt = (val, label) => ({ value: val, label });

  return {
    RULE: [...(rules?.map(idOpt) ?? []), ALL_OPTION],
    STATUS: [
      ...(statuses?.map((s) => enumOpt(s, flagStatuses[s])) ?? []),
      ALL_OPTION,
    ],
    RESOLUTION: [
      ...(resolutions?.map((r) => enumOpt(r, resolutionStatuses[r])) ?? []),
      ALL_OPTION,
    ],
    REPORT: [
      ...(reports?.map((r) => enumOpt(r, reportsLabels[r])) ?? []),
      ALL_OPTION,
    ],
  };
};
